import { makeStyles } from 'tss-react/mui'

export const textBoxStyles = makeStyles()(theme => ({
  container: {
    width: '100%'
  },
  titleContainer: { display: 'flex', marginTop: '10px', marginBottom: '5px' },
  titleFontStyle: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.text
  },
  formDescription: {
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: theme.colors.text
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '18px',
      fontSize: '12px',
      height: '99px'
    },
    '& .MuiInputBase-root': {
      '& input': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxShadow: '0 0 0 1000px white inset'
      }
    }
  },
  smallTextBox: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '18px',
      fontSize: '12px',
      height: '36px'
    }
  },
  titleSymbol: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.redError
  }
}))

export const customSelectStyles = makeStyles()(theme => ({
  disabledOptionText: {
    fontSize: '12px',
    color: theme.colors.textGray
  },
  disabledOptionContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '16px',
    paddingTop: '8px'
  },
  formControl: { width: '100%', fontSize: '12px' },
  titleContainer: { display: 'flex', marginTop: '10px', marginBottom: '5px' },
  titleSymbol: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.redError
  },
  titleFontStyle: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.gray
  },
  selectStyle: {
    borderRadius: 30,
    height: '36px',

    '&.Mui-disabled': {
      '& .MuiSelect-select': {
        color: `${theme.colors.textGray} !important`,
        WebkitTextFillColor: `${theme.colors.textGray} !important`
      },

      '& .MuiSelect-icon': {
        color: theme.colors.textGray
      },

      '& .intemsFontPlaceholder': {
        color: theme.colors.textGray,
        WebkitTextFillColor: theme.colors.textGray
      }
    }
  },
  itemsFontStyle: { fontSize: '12px' },
  intemsFontPlaceholder: { fontSize: '12px', color: theme.colors.textGray }
}))

export const selectionButtonStyles = makeStyles()(theme => ({
  box: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  button: {
    fontSize: 12,
    fontWeight: '400',
    fontFamily: 'Rubik',
    color: theme.colors.gray
  },
  divider: {
    margin: '20px 0',
    borderColor: theme.colors.textGray
  },
  inputListEmpty: {
    height: 'auto'
  },
  inputList: {
    minHeight: 'inherit'
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '10px',
    marginBottom: '5px',
    width: '100%'
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '8px 0'
  },
  removeIconsButton: {
    color: theme.colors.grayText,
    margin: '0 8px',
    padding: '0',
    textAlign: 'center',
    width: 'fit-content',
    minWidth: 'fit-content',
    '&:hover': {
      backgroundColor: 'inherit',
      borderColor: 'inherit',
      boxShadow: 'none'
    },
    '&.Mui-disabled': {
      color: theme.colors.gray2
    }
  },
  titleSymbol: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.redError
  },
  titleFontStyle: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '12px',
    fontWeight: 400,
    color: theme.colors.gray
  },
  textField: {
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: theme.colors.text
    },
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '18px',
      fontSize: '12px',
      height: '99px'
    },
    '& .MuiInputBase-root': {
      '& input': {
        WebkitBoxShadow: `0 0 0 1000px ${theme.colors.white} inset`
      }
    }
  }
}))

export const photosListComponentStyles = makeStyles()(theme => ({
  divider: {
    margin: '20px 0',
    borderColor: theme.colors.textGray
  },
  photoHeaderText: {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '14px',
    fontFamily: 'Rubik'
  }
}))

export const attachmentsListComponentStyles = makeStyles()(theme => ({
  divider: {
    margin: '20px 0',
    borderColor: theme.colors.textGray
  },
  attachmentHeaderText: {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '14px',
    fontFamily: 'Rubik'
  }
}))

export const multiSelectionButtonStyles = makeStyles()(theme => ({
  divider: {
    paddingTop: '20px'
  },
  photoHeaderText: {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '14px',
    fontFamily: 'Rubik'
  }
}))

export const confirmDialogStyles = makeStyles()(theme => ({
  switchDialog: {
    borderRadius: '9px',
    padding: '15px'
  },
  dialogTitle: {
    fontWeight: 'bold',
    fontSize: '24px',
    alignItems: 'center',
    textAlign: 'center'
  },
  dialogContent: {
    fontSize: '18px',
    color: theme.colors.basicDisabledButtonColor,
    textAlign: 'center'
  },
  dialogHighlightText: {
    fontSize: '18px',
    fontWeight: '700',
    color: theme.colors.basicDisabledButtonColor,
    textAlign: 'center'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    columnGap: '30px',
    width: '100%',
    padding: '0px 20px'
  },
  buttonStyle: {
    borderRadius: '44px',
    textTransform: 'none',
    fontSize: '14.29px',
    padding: '10px 30px',
    fontWeight: 'bold',
    minWidth: '90px',
    height: '42px',
    color: theme.colors.dialog.text_grey,
    borderColor: theme.colors.dialog.border,
    '&:hover': {
      backgroundColor: theme.colors.dialog.hover,
      borderColor: theme.colors.dialog.hover,
      boxShadow: 'none'
    }
  },
  okButton: {
    borderRadius: '44px',
    textTransform: 'none',
    fontSize: '14.29px',
    padding: '10px 30px',
    fontWeight: 'bold',
    minWidth: '90px',
    height: '42px',
    color: theme.colors.dialog.text_white,
    border: '0.5px solid ' + theme.colors.dialog.ok_button,
    backgroundColor: theme.colors.dialog.ok_button,
    '&:hover': {
      backgroundColor: theme.colors.dialog.hover,
      borderColor: theme.colors.dialog.hover,
      boxShadow: 'none'
    }
  }
}))
